export default __webpack_public_path__ + "static/media/logo.64bcffc7.png";